import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			header: {
				width: "100%",
				top: "10px",
				position: "relative",
				"& > img": {
					width: "100%"
				}
			},
			headerSecond: {
				color: theme.palette.grey[400],
				display: "flex",
				justifyContent: "flex-end",
				webkitJustifyContent: "flex-end"
			},
			btnClose: {
				position: "absolute",
				top: "50%",
				right: "0px",
				transform: "translate(0, -50%)",
				color: theme.palette.common.white
			},
			customDialog: {
				overflow: "hidden !important"
			},
			customDialogSecond: {
				overflow: "hidden !important",
				boxShadow: "none",
				background: "#00000000"
			},
			body: {
				textAlign: "center",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				flexWrap: "wrap",
				alignItems: "center"
			},
			titleHappy: {
				textTransform: "uppercase",
				fontSize: 16,
				color: theme.palette.common.black,
				fontWeight: 500,
				marginTop: 30
			},
			title: {
				fontSize: 14,
				fontWeight: 400,
				color: theme.palette.common.black,
				marginTop: 10
			},
			subTitle: {
				fontSize: 12,
				fontWeight: 400,
				padding: "15px 10px 0px",
				color: theme.palette.grey[700]
			},
			btnSubmit: {
				color: theme.palette.secondary.main,
				fontSize: 15,
				fontWeight: 400,
				cursor: "pointer",
				padding: 15,
				"&:hover": {
					color: theme.palette.secondary.main,
					opacity: 0.7
				}
			},
			borderRight: {
				borderRight: `1px solid ${theme.palette.grey[800]}`
			},
			driver: {
				marginTop: 20,
				borderTop: `1px solid ${theme.palette.grey[200]}`,
				width: "100%"
			},
			btnCancel: {
				background: theme.palette.grey["A100"],
				color: theme.palette.primary.contrastText,
				border: `1px solid ${theme.palette.grey[900]}`,
				fontSize: 12,
				textTransform: "inherit",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: 36,
				width: "100%",
				borderRadius: 6,
				cursor: "pointer",
				"&:active": {
					opacity: 0.7
				}
			},
			btnConfirm: {
				background: theme.palette.primary.main,
				color: theme.palette.primary.contrastText,
				fontSize: 12,
				textTransform: "inherit",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: 36,
				width: "100%",
				borderRadius: 6,
				borderColor: theme.palette.grey["A100"],
				cursor: "pointer",
				"&:active": {
					opacity: 0.7
				}
			},
			bodyFooter: {
				marginTop: 10,
				padding: "0px 18px 20px"
			}
		}),
	{
		name: "DialogInformation",
		index: 1
	}
);

export default useStyles;
